<template>
  <div class="edge-host">
    <div class="edge-host-top">
      <el-button class="btn btn-left btn-all" @click="addEdgeClick(1)" :disabled="newPrivilege==1" :class="[newPrivilege==1?'active':'']">新建边缘主机 +</el-button>
      <div style="clear:both;"></div>
    </div>
    <div class="edge-host-table">
      <el-table
        :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
        :data="yemiandata"
        border
        style="width: 100%">
        <el-table-column
          prop="edge_id"
          label="边缘主机编号"
          width="">
        </el-table-column>
        <el-table-column
          prop="edge_name"
          label="名称"
          width="">
        </el-table-column>
        <el-table-column
          prop="station_ids"
          label="场站编号">
        </el-table-column>
        <el-table-column
          prop="station_names"
          label="场站名称"
          width="">
        </el-table-column>
        <el-table-column
          prop="ip"
          label="IP"
          width="">
          <template slot-scope="scope">{{ scope.row.ip | defaultValFilter }}</template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
          <template slot-scope="scope">{{ scope.row.status | defaultValFilter }}</template>
        </el-table-column>
        <el-table-column
          prop="created_time"
          label="创建时间"
          width="">
        </el-table-column>
        <el-table-column
          label="操作"
          width="">
          <template slot-scope="scope"> 
              <el-button class="btn edit" @click="editEdge(scope.row,2)" :disabled="editPrivilege==1" :class="[editPrivilege==1?'active':'']">编辑</el-button>
              <!-- <el-button class="btn delete">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
        <el-pagination
        background
        layout="prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="currentChange"
        :total="totalNum">
        </el-pagination>
    </div>
    <!-- 新建 -->
    <el-dialog
		:visible.sync="addEdgeDialog"
    customClass="edge-dialog"
		width="934px"
    @close="edgeCancelClick"
    :close-on-click-modal="false"
		>
      <p class="title">{{edgeTitle}}</p>
      <div class="line"></div>
      <div class="edge-box">
        <div class="edge-row">
          <div class="edge-l"><span class="star">*</span>场站：</div>
          <div class="edge-r">
            <el-select v-model="edgeProvince" clearable :disabled="dialogNum==2" placeholder="请选择省" @change="edgeProviceChange">
              <el-option
                v-for="item in edgeProvinceList"
                :key="item.province"
                :label="item.province"
                :value="item.province">
              </el-option>
            </el-select>
            <el-select v-model="edgeCity" clearable :disabled="dialogNum==2" placeholder="请选择市" @change="edgeCityChange">
              <el-option
                v-for="item in edgeCityList"
                :key="item.city"
                :label="item.city"
                :value="item.city">
              </el-option>
            </el-select>
            <el-select v-model="edgeStation" clearable :disabled="dialogNum==2" placeholder="请选择场站" @change="edgeStationChange">
              <el-option
                v-for="item in edgeStationList"
                :key="item.station_id"
                :label="item.station_name"
                :value="item.station_id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="edge-row">
          <div class="edge-l"><span class="star">*</span>主机名称：</div>
          <div class="edge-r">
            <el-input v-model="edge_name" clearable placeholder="请输入主机名称"></el-input>
          </div>
        </div>
        <div class="edge-row">
          <div class="edge-l"><span class="star">*</span>主机编号：</div>
          <div class="edge-r">
            <el-input v-model="edge_id" clearable placeholder="唯一，不可修改，不可使用横杠'-'，规则例如：shenzhen_likang_100"></el-input>
          </div>
        </div>
        <div class="edge-row">
          <div class="edge-l"><span class="star">*</span>IP：</div>
          <div class="edge-r">
            <el-input v-model="ip" clearable placeholder="请输入IP"></el-input>
          </div>
        </div>
        <div class="edge-button">
          <el-button class="edge-cancel" @click="edgeCancelClick()">取消</el-button>
          <el-button class="edge-confirm" @click="edgeConfirmClick()">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props:["provincesName","cityName","stationId"],
  data () {
    return {
      addEdgeDialog:false,
      edgeTitle:"",
      tableData: [],
      // 页面需要展现的数据
      yemiandata:[],
      // 页面展现条数
      datanum:10,
      // 开始页数
      startnum:0,
      // 结束页数
      endnum:1,
      // 一共多少页
      totalNum:0,
      dialogNum:0,
      edgeProvinceList:[],
      edgeProvince:"",
      edgeCityList:[],
      edgeStationList:[],
      edgeCity:"",
      edgeStation:"",
      edge_id:"",
      edge_name:"",
      ip:"",
      edgeId:"",
      newPrivilege:1,//新建
      editPrivilege:1,//编辑
    }
  },
  mounted(){
    this.$nextTick(function() {

      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        if(role[i].view_name == "场站管理"){
          for(let j in role[i].chlid){
            if(role[i].chlid[j].view_name == "设备管理"){
              for(let m in role[i].chlid[j].method){
                if(role[i].chlid[j].method[m].method_name == "新建边缘主机"){
                  this.newPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "编辑边缘主机"){
                  this.editPrivilege = 0;
                }
              }
            }
          }
        }
      }
      
      this.getEdgeList(this.provincesName,this.cityName,this.stationId);
    });
  },
  watch:{
    "stationId":function(newVal,oldVal){
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getEdgeList(this.provincesName,this.cityName,this.stationId);
    },
  },
  methods:{
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
    },
    getEdgeList(provincesName,cityName,stationId){
      if(provincesName==undefined){
          provincesName = "";
      }
      if(cityName==undefined){
          cityName = "";
      }
      if(stationId==undefined){
          stationId = "";
      }

      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"getEdgeList",
          province:provincesName,
          city:cityName,
          station_id:stationId,
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.tableData = su.data.list;
                  this.totalNum = this.tableData.length;
                  if(this.totalNum > 10){
                    this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
                  } else {
                    this.yemiandata=this.tableData;
                  }
                  
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    addEdgeClick(num){
      this.addEdgeDialog = true;
      this.edgeTitle = "新建边缘主机";
      this.getProvinces();
      this.dialogNum = num;
    },
    getProvinces(){
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_provinces",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.edgeProvinceList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    edgeProviceChange(province){
      this.edgeCity = "";
      this.edgeCityList = [];
      this.edgeStation = "";
      this.edgeStationList = [];
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          province:province,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_citys",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.edgeCityList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    edgeCityChange(city){
      this.edgeStation = "";
      this.edgeStationList = [];
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          city:city,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_stations",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.edgeStationList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    edgeStationChange(id){
      this.edgeStation = id;
    },
    edgeCancelClick(){
      this.addEdgeDialog = false;
      this.edgeProvince = "";
      this.edgeCity = "";
      this.edgeCityList = [];
      this.edgeStation = "";
      this.edgeStationList = [];
      this.edge_id = "";
      this.edge_name = "";
      this.ip = "";
    },
    edgeConfirm(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"addEdge",
        station_id:this.edgeStation,
        edge_id:this.edge_id,
        edge_name:this.edge_name,
        ip:this.ip,
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.$message.success(su.data.message);
                  this.addEdgeDialog = false;
                  this.edgeProvince = "";
                  this.edgeCity = "";
                  this.edgeCityList = [];
                  this.edgeStation = "";
                  this.edgeStationList = [];
                  this.edge_id = "";
                  this.edge_name = "";
                  this.ip = "";
                  this.totalNum = 0;
                  this.startnum = 0;
                  this.endnum = 1;
                  // this.getEdgeList();
                  this.getEdgeList();
                  this.$emit('listenToChildEvent', '空');
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    editEdge(row,num){
      this.addEdgeDialog = true;
      this.dialogNum = num;
      this.edgeId = row.id;
      this.edge_id = row.edge_id;
      this.edge_name = row.edge_name;
      this.ip = row.ip;
      this.edgeTitle = "编辑边缘主机";
      this.edgeProvince = row.province;
      this.edgeCity = row.city;
      this.edgeStation = row.station_names;
    },
    edgeEditConfirm(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"editEdge",
        id:this.edgeId,
        station_id:this.edgeStation,
        edge_id:this.edge_id,
        edge_name:this.edge_name,
        ip:this.ip,
      };
      this.$api({
          method: "post",
          url: "/api.php/DeviceManage/index",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.$message.success(su.data.message);
                  this.addEdgeDialog = false;
                  this.getEdgeList(this.provincesName,this.cityName,this.stationId);
                  this.edgeProvince = "";
                  this.edgeCity = "";
                  this.edgeCityList = [];
                  this.edgeStation = "";
                  this.edgeStationList = [];
                  this.edge_id = "";
                  this.edge_name = "";
                  this.ip = "";
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    edgeConfirmClick(){
      if(this.dialogNum == 1){
        this.edgeConfirm();
      } else if(this.dialogNum == 2){
        this.edgeEditConfirm();
      }
    },
    deleteEdge(row){
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:"deleteEdge",
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: ""
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/DeviceManage/index",
            data: params,
            transformRequest: [
              data => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ]
          })
            .then(su => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getEdgeList(this.provincesName,this.cityName,this.stationId);
              } else if (su.data.code == 300)  {
                localStorage.clear(); 
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900)  {
              } else  {
                this.$message.error(su.data.message);
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
  },
}
</script>

<style scoped lang="scss">
.edge-host {
  .edge-host-top {
    .btn {
      border:none;
      color:#ffffff;
    }
    .btn-left {
      float: left;
    }
    .btn-all {
      margin-left: 1%;
      background-color: #0177BD;
    }
    .btn-all.active {
      background-color: #a5a5a5;
    }
  }
  .edge-host-table {
    margin-top: 24px;
    width: 98%;
    margin-left: 1%;
    .btn {
      width: 54px;
      height: 26px;
      color:#ffffff;
      border:none;
      padding:0;
      text-align: center;
      font-size: 12px;
    }
    .edit {
      background-color: #0171BB;
    }
    .edit.active {
      background-color: #a5a5a5;
    }
    .delete {
      background-color: #00B270;
    }
    .rate {
      background-color: #F15500;
    }
    .disabled {
      background-color: #01A2B4;
    }
    .el-button+.el-button {
      margin-left: 5px;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    margin-right: 18px;
  }
  .edge-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top:16px;
      color: #0171BD;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
      margin-bottom: 30px;
    }
    .edge-box {
      .edge-row {
        width: 90%;
        margin-bottom: 16px;
        .edge-l {
          width: 20%;
          display: inline-block;
          text-align: right;
          .star {
            color: #EE0000;
            margin-right: 4px;
          }
        }
        .edge-r {
          width: 75%;
          display: inline-block;
          .el-select {
            width: 32.5%;
          }
          .el-input {
            width: 99%;
          }
        }
      }
    }
    .edge-button {
      margin-top: 40px;
      .edge-cancel {
        width: 30%;
        background-color: #0071BD;
        color:#ffffff;
        border:none;
        height: 50px;
      }
      .edge-confirm {
        width: 30%;
        background-color: #02B36F;
        color:#ffffff;
        border:none;
        height: 50px;
      }
    }
  }
}
</style>
<style lang="scss">
.edge-host .el-table--enable-row-hover .el-table__body tr:hover>td .edit {
  background-color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/components/stationManagement/edgeHost.vue